import { AlertTriangle, CheckCircle2 } from 'lucide-react'

const problems = [
  'AI agents generate UI fast but inconsistent',
  'Hard to enforce spacing/typography semantics',
  'Design drift across teams and apps',
]

const solutions = [
  'Token-driven UI = predictable output',
  'Semantic color system',
  'Component abstraction',
  'Enables instruction-based AI development',
]

export function ProblemSolution() {
  return (
    <section className="bg-gray-50 py-24 dark:bg-[#0A0A0B]">
      <div className="mx-auto max-w-[1152px] px-6">
        {/* Section Title */}
        <h2 className="mb-16 text-center font-sans text-3xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
          Built for consistent UI — even when AI writes the UI.
        </h2>

        {/* Two Columns */}
        <div className="grid gap-8 md:grid-cols-2 md:gap-12">
          {/* Problem Column */}
          <div className="rounded-2xl border border-gray-200 bg-white p-8 dark:border-white/10 dark:bg-[#111113]">
            <div className="mb-6 flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-red-100 dark:bg-red-500/10">
                <AlertTriangle className="h-5 w-5 text-red-500 dark:text-red-400" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                The problem
              </h3>
            </div>
            <ul className="space-y-4">
              {problems.map((problem, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-gray-600 dark:text-white/70"
                >
                  <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-red-400 dark:bg-red-400/60" />
                  {problem}
                </li>
              ))}
            </ul>
          </div>

          {/* Solution Column */}
          <div className="rounded-2xl border border-[#448AFF]/20 bg-[#448AFF]/5 p-8">
            <div className="mb-6 flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#448AFF]/10">
                <CheckCircle2 className="h-5 w-5 text-[#448AFF]" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Garmisch solves this
              </h3>
            </div>
            <ul className="space-y-4">
              {solutions.map((solution, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-gray-600 dark:text-white/70"
                >
                  <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#448AFF]" />
                  {solution}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Highlight Line */}
        <div className="mt-12 text-center">
          <p className="inline-block rounded-full border border-gray-200 bg-white px-6 py-3 font-mono text-sm text-gray-700 dark:border-white/10 dark:bg-white/5 dark:text-white/80">
            "Consistency is not a guideline — it's an API."
          </p>
        </div>
      </div>
    </section>
  )
}
